import { AuthContext } from "./AuthContext";
import { useContext } from "react";

export const useAuthState = () => {
  const auth = useContext(AuthContext);
  if (!auth) {
    throw new Error("useAuthState must be used within the AuthProvider");
  }

  return auth;
};

export const useCurrentUser = () => {
  const auth = useAuthState();
  if (!auth.currentUser) {
    throw new Error(
      "useCurrentUser must be used **after** the current user has been fetched.",
    );
  }

  return auth.currentUser;
};
